import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, EmptyState } from "../components/common";
import { EnvelopeSimple, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function EmailLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/email-log").then((r) => setItems(r.data)); }, []);
  return (
    <div>
      <PageHeader overline="Notificaciones" title="Historial de correos" />
      {items.length === 0 ? (
        <EmptyState icon={EnvelopeSimple} title="Sin correos" subtitle="Aquí aparecerán los avisos enviados (alertas, aprobaciones, pagos)." />
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                {["Fecha", "Para", "Asunto", "Tipo", "Estado"].map((h) => <th key={h} className="px-4 py-3 overline">{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {items.map((e, i) => (
                <tr key={i} data-testid={`email-row-${i}`} className="border-b border-border last:border-0 hover:bg-muted/50">
                  <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">{new Date(e.created_at).toLocaleString("es-MX")}</td>
                  <td className="px-4 py-3">{e.to}</td>
                  <td className="px-4 py-3">{e.subject}</td>
                  <td className="px-4 py-3"><span className="inline-flex px-2 py-0.5 rounded-sm text-xs font-medium bg-slate-100 text-slate-700">{e.kind}</span></td>
                  <td className="px-4 py-3">
                    {e.ok ? <span className="inline-flex items-center gap-1 text-success font-semibold"><CheckCircle size={16} weight="fill" /> Enviado</span>
                          : <span className="inline-flex items-center gap-1 text-danger font-semibold" title={e.error}><XCircle size={16} weight="fill" /> Falló</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
